import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookmarkIcon"] */ "/app/src/components/icons/bookmark-icon/bookmark-icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbedIcon","ColumnsIcon","ButtonIcon","SingleImage","ImagesGrid","QuoteIcon","BadgeIcon","LandingPage"] */ "/app/src/components/v1/page-style/admin/editor-console/content/widget/widget.style.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CardSlider"] */ "/app/src/components/v2/molecules/custom-slider/card-slider/card-slider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/capacity-info/capacity-info.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/category-tag/category-tag.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/featured-badge/featured-badge.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["IconLinkButton"] */ "/app/src/components/v3/atoms/icon-link-button/icon-link-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/locations-list/locations-list.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/offers-badge/offers-badge.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/card/card.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/section-container/section-container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["VisibleOn"] */ "/app/src/components/v3/atoms/visible-on/visible-on.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardImageScroller"] */ "/app/src/components/v3/molecules/card-image-scroller/card-image-scroller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CreateAccountBanner"] */ "/app/src/components/v3/molecules/create-account-banner/create-account-banner.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/large-item-with-articles/large-item-with-articles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["MainHero"] */ "/app/src/components/v3/molecules/main-hero/main-hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpecialCards"] */ "/app/src/components/v3/molecules/special-cards/special-cards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubcategoryArticles"] */ "/app/src/components/v3/organisms/subcategory-articles/subcategory-articles.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/columns/columns.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/article/blocks/content/content.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/variables.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/unique/category/category.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/category-hero/category-hero.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["CategoryPageViewGTMEvent"] */ "/app/src/utils/gtmEvents/categoryPageViewGTMEvent.ts");
